<div class="scroll-progress-container">
  <div class="scroll-progress-bar" id="scroll-progress-bar"></div>
</div>

<div class="container" scrollProgress>
  <div class="outer_body_container_wrapper">
    <section #heroSection class="hero-section ai-hero-section" id="hero_sec">
      @if (priceGuide?.heroImg && priceGuide.heroImg !== '') {
        <img
          [ngSrc]="priceGuide.heroImg ?? ''"
          [alt]="$safeNavigationMigration(priceGuide?.imgAltAttribute)"
          fill
          class="hero-background-img"
        />
      }

      <div class="breadcrumb_container">
        <app-breadcrumb-list
          [partsOfUrl]="partsOfUrl"
          [standard_max_width]="true"
          [imageOverlay]="true"
        >
        </app-breadcrumb-list>
      </div>
      <div class="hero-sub-section">
        <div class="hero-section-text">
          <h1>{{ aiPriceGuide?.title }}</h1>

          @if (priceGuide?.content?.sub_header) {
            <p class="sub_header">
              {{ priceGuide?.content?.sub_header }}
            </p>
          }

          <div class="hero-buttons">
            <app-generic-button-with-arrow
              [label]="'PAGES.PRICE_GUIDE.CALCULATE_PRICE' | translate"
              (click)="scrollTo($event, 'price-suggester')"
              [width]="'100%'"
            >
            </app-generic-button-with-arrow>
            <app-generic-button-with-arrow
              [label]="'GENERAL.OFF_NOW' | translate"
              (click)="externalService.goToCreateTask()"
              [width]="'100%'"
              [secondary]="true"
            >
            </app-generic-button-with-arrow>
          </div>
        </div>

        <app-price-average
          [priceLow]="
            Number($safeNavigationMigration(aiPriceGuide?.price_guide?.min))
          "
          [priceMedium]="
            Number($safeNavigationMigration(aiPriceGuide?.price_guide?.middle))
          "
          [priceHigh]="
            Number($safeNavigationMigration(aiPriceGuide?.price_guide?.max))
          "
          [title]="'PAGES.PRICE_GUIDE.INDICATIVE_PRICES' | translate"
        >
        </app-price-average>
      </div>
      <div class="bragging_line_container">
        <div class="bragging_line_inner">
          <app-bragging-line></app-bragging-line>
        </div>
      </div>
    </section>

    <div class="outer_body_container">
      <div class="left_container">
        <nav
          class="table_of_content"
          [ngClass]="{ accordionView: innerWidth < 990 }"
        >
          @if (innerWidth < 990) {
            <div
              (click)="expandTableOfContent()"
              class="expand_table_of_content"
            >
              <h2 class="mobile_h2">{{ 'PLACEHOLDERS.I' | translate }}</h2>
              @if (tableOfContentExpanded) {
                <mat-icon>expand_less</mat-icon>
              } @else {
                <mat-icon>expand_more</mat-icon>
              }
            </div>
          }

          <ul
            class="content"
            [ngClass]="{ isExpanded: tableOfContentExpanded }"
          >
            @if (innerWidth > 990) {
              <h2 style="font-size: 20px; padding-top: 0 !important">
                {{ 'PLACEHOLDERS.I' | translate }}
              </h2>
            }

            @for (section of tableOfContents; track $index) {
              <li class="item">
                <a
                  class="item"
                  (click)="scrollTo($event, section.id)"
                  href="#{{ section.id }}"
                  [class.sub-item]="section.level === 3"
                >
                  {{ section.text }}
                </a>
              </li>
            }
          </ul>
        </nav>

        <div class="book_help_container">
          <div class="element_book">
            <p class="title">
              {{ 'GENERAL.CUTS.HELP_WITH' | translate }}
              {{ aiPriceGuide?.relatedCategory?.title }}
            </p>
          </div>
          <div class="element_book">
            <p class="body_txt">{{ 'GENERAL.CUTS.CREATE_TASK' | translate }}</p>
          </div>
          <div class="element_book">
            <app-generic-button-with-arrow
              [width]="'100%'"
              [label]="'GENERAL.CREATE_TASK' | translate"
              (click)="externalService.goToCreateTask()"
            >
            </app-generic-button-with-arrow>
          </div>
          {{ 'GENERAL.CTA.C_1' | translate }}
          <b>{{ 'GENERAL.CTA.C_2' | translate }}</b>
          {{ 'GENERAL.CTA.C_3' | translate }}
        </div>
      </div>

      <div class="body_container">
        @if (aiPriceGuide?.question) {
          <section id="main-question">
            <h2>{{ priceGuide.question }}</h2>
            <strong class="strong">
              @if (answer) {
                <div [innerHTML]="answer | safe: 'html'"></div>
              } @else {
                <div
                  [innerHTML]="priceGuide.shortExplanation | safe: 'html'"
                ></div>
              }
            </strong>
            @if (mapUrl && extendedAddressData) {
              <div class="static-map-container">
                <div
                  class="map-image-container"
                  (click)="openImageViewer([mapUrl], 0)"
                >
                  <img
                    [ngSrc]="mapUrl"
                    fill
                    alt="Rute fra {{ extendedAddressData.fromCity }} til {{
                      extendedAddressData.toCity
                    }}"
                    class="static-map"
                  />
                  <div class="zoom-hint">
                    <mat-icon>zoom_in</mat-icon>
                  </div>
                </div>
                <div class="map-legend">
                  <div class="legend-item">
                    <span class="marker blue">A</span>
                    <span>{{ extendedAddressData.fromCity }}</span>
                  </div>
                  <div class="legend-item">
                    <span class="marker red">B</span>
                    <span>{{ extendedAddressData.toCity }}</span>
                  </div>
                  @if (extendedAddressData.pricePerKm) {
                    <div class="legend-item price-info">
                      <mat-icon>payments</mat-icon>
                      <span
                        >≈
                        {{ extendedAddressData.pricePerKm | formatCurrency }}/km
                        ({{ extendedAddressData.distance }} km)</span
                      >
                    </div>
                  }
                </div>
              </div>
            }
            <br />
          </section>
        }

        @if (aiPriceGuide?.task) {
          <div class="task-example">
            <h3 id="task-example">
              {{ 'PAGES.PRICE_GUIDE.TASK_EXAMPLE' | translate }}
            </h3>
            <p>
              {{ 'PAGES.PRICE_GUIDE.TASK_EXAMPLE_DESC' | translate }}
              <a
                [href]="
                  externalService.taskLinkUrl(aiPriceGuide?.task?.id ?? '')
                "
                target="_blank"
                rel="noreferrer"
              >
                {{ aiPriceGuide?.task?.title }}</a
              >. {{ 'PAGES.PRICE_GUIDE.TASK_EXAMPLE_DESC_2' | translate }}
            </p>
            <div class="task-card example-card">
              <div class="task-content">
                <h4>
                  <a
                    [href]="
                      externalService.taskLinkUrl(aiPriceGuide?.task?.id ?? '')
                    "
                    target="_blank"
                    rel="noreferrer"
                  >
                    {{ aiPriceGuide?.task?.title }}
                  </a>
                </h4>

                @if (taskImages.length > 1) {
                  <div class="task-thumbnails">
                    @for (image of taskImages; track $index) {
                      <div
                        class="thumbnail"
                        (click)="openImageViewer(taskImages, $index)"
                      >
                        <img
                          [ngSrc]="image"
                          [width]="280"
                          [height]="140"
                          [alt]="taskTitle"
                          (error)="onImgError($event)"
                          loading="lazy"
                        />
                      </div>
                    }
                  </div>
                }
                <h5>
                  <strong
                    >{{ 'PAGES.PRICE_GUIDE.DESCRIPTION' | translate }}:</strong
                  >
                </h5>
                <p class="task-description">
                  {{ aiPriceGuide?.task?.description }}
                </p>

                <div class="task-meta">
                  <div class="meta-item">
                    @if (aiPriceGuide?.task?.location) {
                      <mat-icon>location_on</mat-icon>
                      <span
                        >{{ 'PAGES.PRICE_GUIDE.LOCATION' | translate }}:</span
                      >
                      {{ aiPriceGuide?.task?.location }}
                    }
                  </div>
                  <div class="meta-item">
                    @if (aiPriceGuide?.task?.budget) {
                      <mat-icon>account_balance_wallet</mat-icon>
                      <span>{{ 'PAGES.PRICE_GUIDE.BUDGET' | translate }}:</span>
                      {{
                        $safeNavigationMigration(aiPriceGuide?.task?.budget)
                          | formatCurrency
                      }}
                    }
                  </div>
                  <div class="meta-item">
                    <mat-icon>event</mat-icon>
                    <span
                      >{{ 'PAGES.PRICE_GUIDE.CREATED_AT' | translate }}:</span
                    >
                    {{
                      $safeNavigationMigration(aiPriceGuide?.task?.createdAt)
                        | date
                    }}
                  </div>

                  @if (aiPriceGuide?.task?.extendedData) {
                    <div class="meta-item extended-data">
                      <mat-icon>directions</mat-icon>
                      <div class="extended-info">
                        <div class="location-info">
                          <span
                            >{{
                              'PAGES.PRICE_GUIDE.FROM_LOCATION' | translate
                            }}:</span
                          >
                          {{
                            aiPriceGuide?.task?.extendedData?.fromAddress?.city
                          }}
                        </div>
                        <div class="location-info">
                          <span
                            >{{
                              'PAGES.PRICE_GUIDE.TO_LOCATION' | translate
                            }}:</span
                          >
                          {{
                            aiPriceGuide?.task?.extendedData?.toAddress?.city
                          }}
                        </div>
                        <div class="distance-info">
                          <span
                            >{{
                              'PAGES.PRICE_GUIDE.DISTANCE' | translate
                            }}:</span
                          >
                          {{ aiPriceGuide?.task?.extendedData?.distance }}
                          {{ 'PAGES.PRICE_GUIDE.KM' | translate }}
                        </div>
                        <div class="stairs-info">
                          <span>
                            <span
                              >{{
                                'PAGES.PRICE_GUIDE.ACCESSIBILITY' | translate
                              }}:</span
                            >
                            <span class="accessibility-info">
                              @switch (
                                aiPriceGuide?.task?.extendedData
                                  ?.movingStairType
                              ) {
                                @case ('STAIRS') {
                                  {{ 'PAGES.PRICE_GUIDE.STAIRS' | translate }}
                                }
                                @case ('ELEVATOR') {
                                  {{ 'PAGES.PRICE_GUIDE.ELEVATOR' | translate }}
                                }
                                @default {
                                  {{
                                    'PAGES.PRICE_GUIDE.NO_STAIRS' | translate
                                  }}
                                }
                              }
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                </div>

                @if (filteredTaskOffers.length) {
                  <div class="offers-section">
                    <h5>
                      {{ 'PAGES.PRICE_GUIDE.OFFERS' | translate }} ({{
                        filteredTaskOffers.length
                      }})
                    </h5>
                    <div class="offers-list">
                      @for (
                        offer of filteredTaskOffers;
                        track trackByOfferId($index, offer)
                      ) {
                        <div class="offer-item">
                          <a
                            [href]="
                              externalService.profileUrl(offer?.user?.id ?? '')
                            "
                            target="_blank"
                            rel="noreferrer"
                          >
                            @if (offer?.user?.profileImg) {
                              <img
                                [ngSrc]="offer.user.profileImg"
                                [width]="45"
                                [height]="45"
                                [alt]="offer.user.firstName"
                                class="user-avatar"
                                (error)="onProfileImgError($event)"
                              />
                            } @else {
                              <img
                                src="/assets/svg/icons/profile-placeholder.svg"
                                [alt]="
                                  $safeNavigationMigration(
                                    offer?.user?.firstName
                                  )
                                "
                                class="user-avatar"
                              />
                            }
                          </a>
                          <div class="offer-details">
                            <div class="offer-user">
                              <div class="offer-user-info">
                                <span class="user-name">
                                  <a
                                    [href]="
                                      externalService.profileUrl(
                                        offer?.user?.id ?? ''
                                      )
                                    "
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {{ offer?.user?.firstName }}
                                  </a>
                                </span>
                                @if (offer?.user?.rating) {
                                  <div class="user-rating">
                                    <app-svg-star
                                      [active]="true"
                                    ></app-svg-star>
                                    <span>{{ offer?.user?.rating }}</span>
                                  </div>
                                }
                              </div>
                            </div>
                            <div class="offer-price">
                              {{ offer.priceBid | formatCurrency }}
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                <div class="button-container">
                  <app-generic-button-with-arrow
                    [label]="'GENERAL.SIMILAR_TASKS_BTN' | translate"
                    (click)="externalService.goToCreateTask()"
                  >
                  </app-generic-button-with-arrow>
                </div>
              </div>
            </div>
          </div>
        }

        <section class="main_text_container">
          @if (richTextSection.title) {
            <h2 id="rich-text">
              {{ richTextSection.title }}
            </h2>
          }

          <div
            class="content_from_mongo"
            [innerHTML]="richTextSection.content"
          ></div>

          <!-- Market Insights Section -->
          @if (similarTasks.length > 0) {
            @if (marketInsights.title) {
              <div
                id="market-insights"
                class="market-insights content_from_mongo"
              >
                <h2>{{ marketInsights.title }}</h2>
                @if (marketInsights.stats) {
                  <div class="stats">
                    <div class="stat">
                      <span
                        >{{
                          'PAGES.PRICE_GUIDE.SIMILAR_TASKS' | translate
                        }}:</span
                      >
                      <strong>{{
                        marketInsights.stats?.totalSimilarTasks
                      }}</strong>
                    </div>
                    <div class="stat">
                      <span
                        >{{
                          'PAGES.PRICE_GUIDE.AVERAGE_OFFERS' | translate
                        }}:</span
                      >
                      <strong>{{
                        $safeNavigationMigration(
                          marketInsights.stats?.averageOfferCount
                        ) | number: '1.0-1'
                      }}</strong>
                    </div>
                    <div class="stat">
                      <span
                        >{{
                          'PAGES.PRICE_GUIDE.AVERAGE_PRICE' | translate
                        }}:</span
                      >
                      <strong>{{
                        $safeNavigationMigration(
                          marketInsights.stats?.averageOfferPrice
                        ) | formatCurrency
                      }}</strong>
                    </div>
                  </div>
                }
                @if (marketInsights?.content) {
                  <div
                    [innerHTML]="marketInsights.content || '' | safe: 'html'"
                  ></div>
                }
              </div>
            }
          }

          <!-- Similar Tasks Section -->
          <app-similar-tasks
            [similarTasks]="similarTasks"
            (imageViewerOpen)="openImageViewer($event.images, $event.index)"
          >
          </app-similar-tasks>

          @if (aiPriceGuide?.relatedCategory?.title) {
            <app-price-guides-price-suggester
              id="price-suggester"
              [url]="slug"
              [verticalVersion]="false"
              [titleLabel]="
                ('TOOLS.PRICE_SUGGESTER.TITLE_PREFIX' | translate) +
                $safeNavigationMigration(aiPriceGuide?.relatedCategory?.title)
              "
              [descriptionLabel]="
                $safeNavigationMigration(aiPriceGuide?.relatedCategory?.title)
              "
            >
            </app-price-guides-price-suggester>
          }

          <!-- Who Can Hire Section -->
          @if (whoCanHireSection.title) {
            <div
              class="who-can-hire-section content_from_mongo"
              id="who-can-hire"
            >
              <h2>{{ whoCanHireSection.title }}</h2>
              <div
                [innerHTML]="
                  $safeNavigationMigration(whoCanHireSection?.body)
                    | safe: 'html'
                "
              ></div>
              @if (taskOfferUsers.length > 0) {
                <div class="task-users-section">
                  <h3>
                    {{ 'PAGES.PRICE_GUIDE.PEOPLE_WHO_COMPLETE' | translate }}
                  </h3>
                  <div class="task-users-grid">
                    @for (
                      user of taskOfferUsers;
                      track trackByUserId($index, user)
                    ) {
                      <div class="task-user-card">
                        <div class="user-header">
                          <a
                            [href]="externalService.profileUrl(user?.id ?? '')"
                            target="_blank"
                            rel="noreferrer"
                          >
                            @if (user?.profileImg) {
                              <img
                                [ngSrc]="user.profileImg"
                                [width]="40"
                                [height]="40"
                                [alt]="user.name"
                                (error)="onProfileImgError($event)"
                                class="user-avatar"
                              />
                            } @else {
                              <img
                                src="/assets/svg/profile_img_placeholder 70x70.png"
                                [alt]="user.name"
                                class="user-avatar"
                              />
                            }
                          </a>
                          <div class="user-info">
                            <h4
                              class="user-name"
                              style="text-transform: capitalize"
                            >
                              <a
                                [href]="externalService.profileUrl(user.id)"
                                target="_blank"
                                rel="noreferrer"
                              >
                                {{ user.firstName }}
                              </a>
                            </h4>
                            <div class="user-stats">
                              @if (user.rating > 0) {
                                <span class="rating">
                                  <app-svg-star [active]="true"></app-svg-star>
                                  <span class="rating-number">{{
                                    formatRating(user.rating)
                                  }}</span>
                                </span>
                              }
                              @if (user.rating === 0) {
                                <span class="rating">
                                  {{
                                    'PAGES.PRICE_GUIDE.NO_RATING' | translate
                                  }}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                        @if (getUserCategories(user)) {
                          <div class="user-categories">
                            <strong
                              >{{
                                'PAGES.PRICE_GUIDE.SPECIALIZES_IN' | translate
                              }}:</strong
                            >
                            {{ getUserCategories(user) }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }

          @if (faqSection.length > 0) {
            <section
              id="faq-section"
              class="page-faqs content_from_mongo"
              itemscope
              itemtype="https://schema.org/FAQPage"
            >
              <h2 class="title">{{ 'COMPONENTS.FAQ.Q3' | translate }}</h2>
              <ul class="faq-list">
                @for (faq of faqSection; track trackByFaqId($index, faq)) {
                  <li
                    class="faq-list-item"
                    itemscope
                    itemprop="mainEntity"
                    itemtype="https://schema.org/Question"
                  >
                    <input
                      class="faq-list-item__toggle"
                      type="checkbox"
                      checked=""
                      [id]="'faq' + $index"
                    />
                    <label
                      [for]="'faq' + $index"
                      class="faq-list-item__title"
                      itemprop="name"
                    >
                      <h3>{{ faq?.TITLE }}</h3>
                    </label>
                    <div
                      class="faq-list-item__answer"
                      itemscope
                      itemprop="acceptedAnswer"
                      itemtype="https://schema.org/Answer"
                    >
                      <span itemprop="text">
                        <p
                          [innerHTML]="
                            $safeNavigationMigration(faq?.TEXT) | safe: 'html'
                          "
                        ></p>
                      </span>
                    </div>
                  </li>
                }
              </ul>
            </section>
          }
        </section>
      </div>
    </div>
  </div>

  @if (relatedGuides.length > 0) {
    <section class="related-guides">
      <div class="max_width_price_page">
        <h3>{{ 'PAGES.PRICE_GUIDE.RELATED_GUIDES' | translate }}</h3>
        <div class="guides-scroll">
          <div class="guides-grid">
            @for (guide of relatedGuides; track guide._id) {
              <div class="guide-card">
                <div class="guide-content">
                  <h3>
                    <a [href]="guide.finalSlug" (click)="scrollToTop()">
                      {{ guide.title }}
                    </a>
                  </h3>
                  @if (guide?.answer) {
                    <p class="guide-description">{{ guide.answer }}</p>
                  }
                  <div class="guide-meta">
                    @if (guide.price_guide) {
                      <div class="price-range">
                        <mat-icon>payments</mat-icon>
                        <span>{{
                          guide.price_guide.min
                            | formatCurrencyRange: guide.price_guide.max
                        }}</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </section>
  }

  <div class="max_width_price_page">
    <section class="cta_section outer_seo_page_component_container">
      <div class="inner_seo_page_component_container cta_inner">
        <div class="img_wrapper">
          <img [src]="womanWithPhone" alt="Kvinde med telefon" />
        </div>
        <div class="text_section">
          <div>
            <h2>
              {{ 'GENERAL.CUTS.FIND_A' | translate }}
              {{ categoryTitle }}
            </h2>
          </div>
          <app-generic-button-with-arrow
            [label]="('GENERAL.CUTS.FIND' | translate) + ' ' + categoryTitle"
            (click)="
              externalService.goToCreateTask({
                title: categoryTitle,
              })
            "
          >
          </app-generic-button-with-arrow>
        </div>
      </div>
    </section>
  </div>
  <app-lp-footer></app-lp-footer>
</div>

@if (showImageViewer) {
  <app-image-viewer
    [images]="selectedTaskImages"
    [startIndex]="selectedImageIndex"
    (closed)="closeImageViewer()"
  >
  </app-image-viewer>
}
<div [innerHTML]="breadCrumbSchema | jsonLd"></div>
<div [innerHTML]="priceSchema | jsonLd"></div>
